import { render, staticRenderFns } from "./ActusPage.vue?vue&type=template&id=74ba8010&"
import script from "./ActusPage.vue?vue&type=script&lang=js&"
export * from "./ActusPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports